// Red cell when a certification expired before the good-standing as-of date
const EXPIRED_STYLE = { backgroundColor: '#dd758a', color: '#FFFFFF' };

// YYYYMMDD int, local parts, so highlight matches the text Kendo displays.
// Non-date cell values (a reason string, null) give no highlight.
const toDayNumber = (value) => {
  if (!(value instanceof Date) || isNaN(value.getTime())) {
    return null;
  }

  return value.getFullYear() * 10000 + (value.getMonth() + 1) * 100 + value.getDate();
};

const asOfDayNumber = (asOfDate) => {
  const parts = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(asOfDate || '');

  if (parts === null) {
    return null;
  }

  const month = Number(parts[1]);
  const day = Number(parts[2]);
  const year = Number(parts[3]);

  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1) {
    return null;
  }

  return year * 10000 + month * 100 + day;
};

const makeExpirationCell = (goodStandingAsOfDate) => {
  const asOf = asOfDayNumber(goodStandingAsOfDate);

  const ExpirationCell = (props) => {
    const { tdProps, dataItem, field, children } = props;
    const expiration = toDayNumber(dataItem[field]);
    const isExpired = asOf !== null && expiration !== null && expiration < asOf;

    return (
      <td
        {...tdProps}
        style={isExpired ? { ...tdProps?.style, ...EXPIRED_STYLE } : tdProps?.style}>
        {children}
      </td>
    );
  };

  return ExpirationCell;
};

export default makeExpirationCell;
